import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/AuthService";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (newPassword.length < 10 || newPassword.length > 72) {
      setError("Le nouveau mot de passe doit contenir entre 10 et 72 caractères.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("La confirmation du nouveau mot de passe ne correspond pas.");
      return;
    }

    try {
      setLoading(true);

      await changePassword(currentPassword, newPassword);

      setMessage("Mot de passe modifié avec succès. Vous allez être déconnecté.");

      localStorage.removeItem("userDetails");

      setTimeout(() => {
        navigate("/login");
        window.location.reload();
      }, 1200);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        "Impossible de modifier le mot de passe."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-xl-6 col-lg-8">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Changer le mot de passe</h4>
            </div>

            <div className="card-body">
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}

              {message && (
                <div className="alert alert-success">
                  {message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Mot de passe actuel</label>
                  <input
                    type="password"
                    className="form-control"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Nouveau mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    minLength={10}
                    maxLength={72}
                    autoComplete="new-password"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Confirmer le nouveau mot de passe
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    minLength={10}
                    maxLength={72}
                    autoComplete="new-password"
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Modification..." : "Modifier le mot de passe"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;